import { render } from "./QuickCraveWorthyDelicious.vue?vue&type=template&id=e5437102&scoped=true"
import script from "./QuickCraveWorthyDelicious.vue?vue&type=script&lang=js"
export * from "./QuickCraveWorthyDelicious.vue?vue&type=script&lang=js"

import "./QuickCraveWorthyDelicious.vue?vue&type=style&index=0&id=e5437102&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5437102"]])

export default __exports__